<h2 mat-dialog-title>Add Assessment</h2>
<div style="padding-left: 10px;">Tabs will be added for the selected assessments</div>
<mat-dialog-content>
  <div *ngFor="let tab of displayTabs; let j = index">
    <tyl-checkbox id='chktab{{j}}' name='chkTab{{j}}' [checked]='selectedTabs.indexOf(tab) > -1'
        (change)="selectTab(tab)" style="padding-right:20px;">{{tab.Code}}
    </tyl-checkbox>
  </div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
  <!-- Left -->
  <div class="flex-footer-left">
  </div>
  <!-- Middle -->
  <div class="flex-footer-middle">
  </div>
  <div class="flex-footer-right">
    <tyl-button image="Save.png" label="Save" (clickEvent)="saveClick()"></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>